const removeDuplicates = (keyFn, array) => {
  const mySet = new Set()
  return array.filter(function (x) {
    const key = keyFn(x),
      isNew = !mySet.has(key)
    if (isNew) mySet.add(key)
    return isNew
  })
}

export default removeDuplicates



// WEBPACK FOOTER //
// ./src/utility/removeDuplicates.js